<template>
  <div class="content">
    <h1 class="has-text-centered">Konstanten</h1>
    <div class="columns">
      <div class="column is-one-third">
        <div class="box is-wordWrapBreakWord is-fullHeight has-text-centered">
          <h3>Elementarladung</h3>
          <p>
            <strong>Formelzeichen: </strong> <span v-katex="'e'"></span><br>
            <strong>Wert:</strong> 1,60217662018 * 10<sup>-19</sup><br>
            <strong>Einheit: </strong> <span v-katex="'C'"></span> (Coulomb)
          </p>
          <p>
            Die <strong>Elementarladung</strong> ist die kleinste frei existierende elektrische Ladungsmenge.
          </p>
        </div>
      </div>
      <div class="column is-one-third">
        <div class="box is-wordWrapBreakWord is-fullHeight has-text-centered">
          <h3>Kreiszahl PI</h3>
          <p>
            <strong>Formelzeichen: </strong> <span v-katex="'\\pi'"></span><br>
            <strong>Wert:</strong> 3,1415926536...<br>
            <strong>Einheit: </strong> einheitenlos
          </p>
          <p>
            Die <strong>Kreiszahl PI</strong> ist eine mathematische Konstante, die als Verhältnis des Umfangs eines Kreises zu seinem Durchmesser definiert ist.
          </p>
        </div>
      </div>
      <div class="column is-one-third">
        <div class="box is-wordWrapBreakWord is-fullHeight has-text-centered">
          <h3>Magnetische Feldkonstante</h3>
          <p>
            <strong>Formelzeichen: </strong> <span v-katex="'\\mu_0'"></span><br>
            <strong>Wert:</strong> 4 * &pi; * 10<sup>-7</sup><br>
            <strong>Einheit: </strong> <span v-katex="'\\frac{Vs}{Am}'"></span>
          </p>
          <p>
            Die <strong>magnetische Feldkonstante</strong> gibt das Verhältnis der magnetischen Flussdichte zur magnetischen Feldstärke im Vakuum an.
          </p>
        </div>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="box is-wordWrapBreakWord is-fullHeight has-text-centered">
          <h3>Elektrische Feldkonstante</h3>
          <p>
            <strong>Formelzeichen: </strong> <span v-katex="'\\epsilon_0'"></span><br>
            <strong>Wert:</strong> 8,854187817 * 10<sup>-12</sup><br>
            <strong>Einheit: </strong> <span v-katex="'\\frac{As}{Vm}'"></span>
          </p>
          <p>
            Die <strong>elektrische Feldkonstante</strong> gibt das Verhältnis der elektrischen Flussdichte zur elektrischen Feldstärke im Vakuum an.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tables-constants',
  metaInfo: {
    title: 'Physikalische Konstanten Tabelle | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Eine Sammlung von physikalischen Konstanten die in der Elektrotechnik verwendet werden.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'tables' })
  }
}
</script>
